import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  emotionColors,
  gray,
  grayShades,
} from '../../../styles/abstracts/colors';
import { fontSizes } from '../../../styles/abstracts/typography';
import { hex2rgbaConvert } from '../../../_Utils/styles/colors';

const getBgColor = ({ isDragReject, isDragActive }) => {
  if (isDragReject) {
    return hex2rgbaConvert(emotionColors.happiness, 20);
  }
  if (isDragActive) {
    return grayShades.g300;
  }
  return 'transparent';
};

const Container = styled.div`
  transition: background-color 0.25s;
  color: ${gray};
  cursor: pointer;
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 190px;
  height: 150px;
  background-color: ${props => getBgColor(props)};
  border: 18px solid white;
  border-image-slice: 18;
  border-image-repeat: round;
  border-radius: 1rem;
  border-image-source: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'><g fill='${gray}' fill-rule='evenodd'><path d='M45,34 C44.4477153,34 44,33.5522847 44,33 C44,32.4477153 44.4477153,32 45,32 L49,32 C49.5522847,32 50,32.4477153 50,33 C50,33.5522847 49.5522847,34 49,34 L45,34 Z' transform='rotate(-90 47 33)'/><path d='M-1,25 C-1.55228475,25 -2,24.5522847 -2,24 C-2,23.4477153 -1.55228475,23 -1,23 L3,23 C3.55228475,23 4,23.4477153 4,24 C4,24.5522847 3.55228475,25 3,25 L-1,25 Z' transform='rotate(-90 1 24)'/><path d='M45,25 C44.4477153,25 44,24.5522847 44,24 C44,23.4477153 44.4477153,23 45,23 L49,23 C49.5522847,23 50,23.4477153 50,24 C50,24.5522847 49.5522847,25 49,25 L45,25 Z' transform='rotate(-90 47 24)'/><path d='M13 2C12.4477153 2 12 1.55228475 12 1 12 .44771525 12.4477153 0 13 0L17 0C17.5522847 0 18 .44771525 18 1 18 1.55228475 17.5522847 2 17 2L13 2zM22 2C21.4477153 2 21 1.55228475 21 1 21 .44771525 21.4477153 0 22 0L26 0C26.5522847 0 27 .44771525 27 1 27 1.55228475 26.5522847 2 26 2L22 2z'/><path d='M-1,16 C-1.55228475,16 -2,15.5522847 -2,15 C-2,14.4477153 -1.55228475,14 -1,14 L3,14 C3.55228475,14 4,14.4477153 4,15 C4,15.5522847 3.55228475,16 3,16 L-1,16 Z' transform='rotate(-90 1 15)'/><path d='M1.52529801,3.97331663 C1.03292685,3.69146319 0.855059112,3.05082565 1.12801929,2.54241265 C1.40097946,2.03399964 2.02140309,1.85033682 2.51377424,2.13219026 C3.87058144,2.90888235 5.01807805,4.03115745 5.8435328,5.38715418 C6.14313206,5.87931397 5.99961968,6.52907451 5.52298891,6.83843497 C5.04635815,7.14779542 4.41709937,6.99960729 4.1175001,6.5074475 C3.47494516,5.4519052 2.58108669,4.57769337 1.52529801,3.97331663 Z' transform='rotate(-90 3.5 4.5)'/><path d='M31,48 C30.4477153,48 30,47.5522847 30,47 C30,46.4477153 30.4477153,46 31,46 L35,46 C35.5522847,46 36,46.4477153 36,47 C36,47.5522847 35.5522847,48 35,48 L31,48 Z' transform='rotate(-180 33 47)'/><path d='M22,48 C21.4477153,48 21,47.5522847 21,47 C21,46.4477153 21.4477153,46 22,46 L26,46 C26.5522847,46 27,46.4477153 27,47 C27,47.5522847 26.5522847,48 26,48 L22,48 Z' transform='rotate(-180 24 47)'/><path d='M13,48 C12.4477153,48 12,47.5522847 12,47 C12,46.4477153 12.4477153,46 13,46 L17,46 C17.5522847,46 18,46.4477153 18,47 C18,47.5522847 17.5522847,48 17,48 L13,48 Z' transform='rotate(-180 15 47)'/><path d='M0,31 C0,30.4477153 0.44771525,30 1,30 C1.55228475,30 2,30.4477153 2,31 L2,35 C2,35.5522847 1.55228475,36 1,36 C0.44771525,36 0,35.5522847 0,35 L0,31 Z' transform='rotate(-180 1 33)'/><path d='M42.525298,42.9733166 C42.0329269,42.6914632 41.8550591,42.0508257 42.1280193,41.5424126 C42.4009795,41.0339996 43.0214031,40.8503368 43.5137742,41.1321903 C44.8705814,41.9088823 46.0180781,43.0311574 46.8435328,44.3871542 C47.1431321,44.879314 46.9996197,45.5290745 46.5229889,45.838435 C46.0463581,46.1477954 45.4170994,45.9996073 45.1175001,45.5074475 C44.4749452,44.4519052 43.5810867,43.5776934 42.525298,42.9733166 Z' transform='rotate(90 44.5 43.5)'/><path d='M1.52529801,42.9733166 C1.03292685,42.6914632 0.855059112,42.0508257 1.12801929,41.5424126 C1.40097946,41.0339996 2.02140309,40.8503368 2.51377424,41.1321903 C3.87058144,41.9088823 5.01807805,43.0311574 5.8435328,44.3871542 C6.14313206,44.879314 5.99961968,45.5290745 5.52298891,45.838435 C5.04635815,46.1477954 4.41709937,45.9996073 4.1175001,45.5074475 C3.47494516,44.4519052 2.58108669,43.5776934 1.52529801,42.9733166 Z' transform='rotate(-180 3.5 43.5)'/><path d='M45,16 C44.4477153,16 44,15.5522847 44,15 C44,14.4477153 44.4477153,14 45,14 L49,14 C49.5522847,14 50,14.4477153 50,15 C50,15.5522847 49.5522847,16 49,16 L45,16 Z' transform='matrix(0 -1 -1 0 62 62)'/><path d='M32,-1 C32,-1.55228475 32.4477153,-2 33,-2 C33.5522847,-2 34,-1.55228475 34,-1 L34,3 C34,3.55228475 33.5522847,4 33,4 C32.4477153,4 32,3.55228475 32,3 L32,-1 Z' transform='matrix(0 -1 -1 0 34 34)'/><path d='M42.525298,3.97331663 C42.0329269,3.69146319 41.8550591,3.05082565 42.1280193,2.54241265 C42.4009795,2.03399964 43.0214031,1.85033682 43.5137742,2.13219026 C44.8705814,2.90888235 46.0180781,4.03115745 46.8435328,5.38715418 C47.1431321,5.87931397 46.9996197,6.52907451 46.5229889,6.83843497 C46.0463581,7.14779542 45.4170994,6.99960729 45.1175001,6.5074475 C44.4749452,5.4519052 43.5810867,4.57769337 42.525298,3.97331663 Z'/></g></svg> ");
`;

const DropZoneTitle = styled.div`
  font-size: ${fontSizes.bigger};
  font-weight: 700;
`;

const DropZoneSubtitle = styled.div`
  font-size: ${fontSizes.default};
`;

const PreviewImage = styled.img`
  max-width: 80%;
  max-height: 80%;
`;

const ErrorMsg = styled.div`
  color: ${emotionColors.happiness};
  text-align: center;
  font-weight: 700;
`;

const QDropzoneBox = ({
  getRootProps,
  getInputProps,
  isDragActive,
  isDragReject,
  previewImg,
  t,
}) => (
  <Container
    isDragActive={isDragActive}
    isDragReject={isDragReject}
    {...getRootProps({ refKey: 'innerRef' })}
  >
    <input {...getInputProps()} />
    {!isDragReject ? (
      previewImg ? (
        <PreviewImage src={previewImg} alt="" />
      ) : (
        [
          <DropZoneTitle>{t('Drop file here')}</DropZoneTitle>,
          <DropZoneSubtitle>{t('or click to upload')}</DropZoneSubtitle>,
        ]
      )
    ) : (
      <ErrorMsg>{t('Incorrect file type')}</ErrorMsg>
    )}
  </Container>
);

QDropzoneBox.propTypes = {
  previewImg: PropTypes.string,
  getRootProps: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
  isDragActive: PropTypes.bool.isRequired,
  isDragReject: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

QDropzoneBox.defaultProps = {
  previewImg: null,
};

export default withTranslation('text')(QDropzoneBox);
